<div class="modal-body">
  <p>{{ 'UNDO_CHECK_IN_EXPLANATION' | translate }}</p>  
</div>

<div class="modal-footer">

  <button id="confirmUndoCheckIn" type="button" (click)="undoCheckIn()" [disabled]="isLoading"
    class="btn btn-block btn-primary lh-btn">
    {{ 'UNDO_CHECK_IN' | translate }}
  </button>

  <button id="abortUndoCheckIn" type="button" (click)="close()" [disabled]="isLoading"
    class="btn btn-block btn-info lh-btn">
    {{ 'STAY_CHECKED_IN' | translate }}
  </button>

  <div class="small-text">{{ 'ONLY_INSURED_WHILE_TIMER_RUNNING' | translate }}</div>

</div>
